import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import ClientLayout from "./components/ClientLayout";
import StaffLayout from "./components/StaffLayout";
import { ClientProtected, StaffProtected } from "./components/ProtectedRoute";

// Client pages
const ClientLoginPage = lazy(() => import("./pages/Client/LoginPage"));
const ClientVerifyPage = lazy(() => import("./pages/Client/VerifyPage"));
const ClientDashboardPage = lazy(() => import("./pages/Client/DashboardPage"));
const ClientBlDetailPage = lazy(() => import("./pages/Client/BlDetailPage"));

// Staff pages
const StaffLoginPage = lazy(() => import("./pages/Staff/LoginPage"));
const StaffMicrosoftCallbackPage = lazy(() => import("./pages/Staff/MicrosoftCallbackPage"));
const StaffDashboardPage = lazy(() => import("./pages/Staff/DashboardPage"));
const StaffBlCreatePage = lazy(() => import("./pages/Staff/BlCreatePage"));
const StaffBlDetailPage = lazy(() => import("./pages/Staff/BlDetailPage"));
const StaffClientsPage = lazy(() => import("./pages/Staff/ClientsPage"));
const StaffUsersPage = lazy(() => import("./pages/Staff/UsersPage"));
const StaffHistoriquesPage = lazy(() => import("./pages/Staff/HistoriquesPage"));

function Loader() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{ background: "linear-gradient(135deg, #f8fff4 0%, #e8f5e8 100%)" }}
    >
      <CircularProgress size={48} sx={{ color: "#6db43d" }} />
    </Box>
  );
}

export default function App() {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* ============ AUTH (public) ============ */}
        <Route path="/login" element={<ClientLoginPage />} />
        <Route path="/auth/verify" element={<ClientVerifyPage />} />
        <Route path="/staff/login" element={<StaffLoginPage />} />
        <Route path="/staff/auth/microsoft/callback" element={<StaffMicrosoftCallbackPage />} />

        {/* ============ CLIENT FINAL (magic link) ============ */}
        <Route
          element={
            <ClientProtected>
              <ClientLayout />
            </ClientProtected>
          }
        >
          <Route path="/" element={<ClientDashboardPage />} />
          <Route path="/bl/:id" element={<ClientBlDetailPage />} />
        </Route>

        {/* ============ STAFF (email/password) ============ */}
        <Route
          element={
            <StaffProtected>
              <StaffLayout />
            </StaffProtected>
          }
        >
          <Route path="/staff" element={<StaffDashboardPage />} />
          <Route path="/staff/bls/new" element={<StaffBlCreatePage />} />
          <Route path="/staff/bls/:id" element={<StaffBlDetailPage />} />
          <Route path="/staff/historiques" element={<StaffHistoriquesPage />} />
        </Route>

        {/* Admin-only sous-routes */}
        <Route
          element={
            <StaffProtected requireAdmin>
              <StaffLayout />
            </StaffProtected>
          }
        >
          <Route path="/staff/clients" element={<StaffClientsPage />} />
          <Route path="/staff/users" element={<StaffUsersPage />} />
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
